export class Exception {
  constructor(message, stack) {
    this.name = 'Exception';
    this.message = message;
    this.stack = stack;
  }
}
